export default "__VITE_ASSET__DQRQ_0ea__"